<template>
  <div>
    <v-text-field
      :disabled="$store.getters.isDisabled"
      :error="errorState"
      :error-messages="errorMessages"
      v-if="responseItem"
      :value="responseItem.client_original_name"
      v-bind="$attrs"
      prepend-icon="mdi-paperclip"
      readonly
    >
      <template #append>
        <v-icon @click="deleteAttachment">mdi-close</v-icon>
      </template>
    </v-text-field>
    <v-file-input
      :disabled="$store.getters.isDisabled"
      :error="errorState"
      :error-messages="errorMessages"
      v-model="file"
      v-bind="$attrs"
      @change="post"
      @click:clear="deleteAttachment"
    ></v-file-input>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: null,
    },
    name: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      required: true, // electricity or room
    },
    typeId: {
      type: Number,
      default: null, // null if electricity or number if room
    },
  },
  data() {
    return {
      file: null,
      responseItem: this.value,
      errorState: null,
      errorMessages: null,
    };
  },
  methods: {
    deleteAttachment() {
      this.axios
        .delete("/attachment/" + this.responseItem.id)
        .then((response) => {
          this.responseItem = null;
          this.file = null;
          if (response.data.attachments) {
            this.$store.commit("SET", { attachments: response.data.attachments });
          }

          this.$store.dispatch("checkValidity");
        })
        .catch((error) => {
          console.error(error);
        });
    },
    post() {
      this.errorState = null;
      this.errorMessages = null;
      if (!this.file) return;

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      let form = new FormData();
      form.append("file", this.file);
      form.append("name", this.name);
      form.append("type", this.type);
      if (this.typeId) form.append("type_id", this.typeId);
      form.append("selection_id", this.$store.state.selection_id);
      form.append("room_id", this.$store.state.selection_id);
      this.axios
        .post("/attachment", form, config)
        .then((response) => {
          this.responseItem = response.data;

          const attachments = this._.cloneDeep(this.$store.state.attachments);
          attachments.push(this.responseItem);
          this.$store.commit("SET", { attachments });
          this.$emit("change", response.data);
          this.$store.dispatch("checkValidity");
        })
        .catch((error) => {
          console.error(error);
          this.errorState = true;
          this.errorMessages = [error.response.data.message];
        });
    },
  },
};
</script>
